import React, { useContext } from "react";

// Context //
import TalentsContext from "../../../contexts/talentsContext";

// Styles //
import "./filterTagEncTal.scss";

interface FilterTagEncTalProps {
    label: string;
    value: number;
    name: string;
}

const FilterTagEncTal = ({ label, value, name }: FilterTagEncTalProps) => {
    const { selectedFilters, setSelectedFilters } = useContext(TalentsContext);
    const onDeleteFilter = () => {
        let isCheckbox = false;
        if (name === "region" || name === "city") {
            setSelectedFilters({
                ...selectedFilters,
                [name]: {
                    items: selectedFilters[name].items.filter(
                        (e) => e.value !== value
                    ),
                },
            });
            isCheckbox = false;
        }
        if (name === "educationLevel" || name === "profession"
            || name === "area" || name === "populationGroup") {
            setSelectedFilters({
                ...selectedFilters,
                [name]: {
                    values: selectedFilters[name].values.filter(
                        (e) => e !== value
                    ),
                    items: selectedFilters[name].items.filter(
                        (e) => e.value !== value
                    ),
                },
            });
            isCheckbox = true;
        }
        if (name === "language" || name === "languageLevel" 
            || name === "keyWord") {
            setSelectedFilters({
                ...selectedFilters,
                [name]: {
                    items: selectedFilters[name].items.filter(
                        (e) => e.value !== value
                    ),
                },
            });
            isCheckbox = false;
        }
        removeSelected(name, value, isCheckbox);
    };

    const removeSelected = (name, value, isCheckbox) => {
        if(isCheckbox){
            const checkbox = document.querySelector(`input[type=checkbox][name="${name}"][value="${value}"]`) as HTMLInputElement;
            if (checkbox) {
                checkbox.checked = false;
            }
        }else{
            const radio = document.querySelector(`input[type=radio][name="${name}"][value="${value}"]`) as HTMLInputElement;
            if (radio) {
                radio.checked = false;
            }
        }
    }

    return (
        <span className="a-label-filter-enc-tal">
            {label}
            <>
                <button onClick={onDeleteFilter}>x</button>
            </>
        </span>
    );
};

export default FilterTagEncTal;
